export default __webpack_public_path__ + "static/media/EM0770.34I-21941_-14981_0.df944744.jpg";